import * as React from 'react'
// libs
import { useContext } from 'react'
// hooks
import { useShowModal } from 'hooks/index'
// constants
import { Modals } from 'constants/index'
// context
import { ResourcesListAPIContext } from 'containers/Activities/layers/API/ResourcesList'
// types
import { IPlanObjectiveResource } from 'types/graphql'

type Props = React.PropsWithChildren<unknown>

export declare namespace NResourcesListBL {
  export interface IContext {
    handleCreateResource: () => void
    handleDeleteResource: (resource: IPlanObjectiveResource) => void
    handleEditResource: (resource: IPlanObjectiveResource) => void
  }
}

export const ResourcesListBLContext = React.createContext<NResourcesListBL.IContext>({} as any)

const ResourcesListBL: React.FC<Props> = ({ children }) => {
  // context
  const { deleteResource, entity, refetch } = useContext(ResourcesListAPIContext)

  // redux
  const { showModal: showCreateResourceModal } = useShowModal({
    modalType: Modals.RESOURCE_CREATE_MODAL
  })

  const { showModal: showDeleteModal } = useShowModal({
    modalType: Modals.CONFIRM_DELETE_ACTIVITY_MODAL
  })

  // methods
  const handleCreateResource = () => showCreateResourceModal({ entity, refetch })

  const handleEditResource = (resource) => {
    showCreateResourceModal({ entity, refetch, resource })
  }

  const handleDeleteResource = (resource) => {
    showDeleteModal({
      handleConfirm: () => {
        deleteResource(resource)
      }
    })
  }

  const value = {
    handleCreateResource,
    handleDeleteResource,
    handleEditResource
  }

  return <ResourcesListBLContext.Provider value={value}>{children}</ResourcesListBLContext.Provider>
}

export default ResourcesListBL
